import { render, staticRenderFns } from "./addLeavePeriods.vue?vue&type=template&id=4b346fc3&scoped=true"
import script from "./addLeavePeriods.vue?vue&type=script&lang=js"
export * from "./addLeavePeriods.vue?vue&type=script&lang=js"
import style0 from "./addLeavePeriods.vue?vue&type=style&index=0&id=4b346fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b346fc3",
  null
  
)

export default component.exports